'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _iBem = require('../../i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ target: 'anchor' }, {
    block: 'popup2',
    willInit: function willInit(_ref) {
        var anchor = _ref.anchor;

        /*%%%ISLDEBUG%%%*/+0 && console.assert(typeof anchor === 'function', 'Передача ссылки на элемент в anchor является устаревшим, ' + 'и в следующей мажорной версии перестанет работать. ' + 'В anchor необходимо передать функцию, которая должна возвращать ссылку на элемент.');
        this.__base.apply(this, arguments);
    },

    // TODO: https://st.yandex-team.ru/ISL-4493
    _getAnchorDomNode: function _getAnchorDomNode(anchor) {
        return typeof anchor === 'function' ? anchor() : anchor;
    },
    _calcBestDrawingParams: function _calcBestDrawingParams(_ref2) {
        var anchor = _ref2.anchor;

        var base = this.__base.apply(this, arguments);

        anchor = (0, _reactDom.findDOMNode)(this._getAnchorDomNode(anchor));

        var fixedAnchor = this._getFirstFixedParent(anchor);
        if (fixedAnchor) {
            base.left -= window.pageXOffset;
            base.top -= window.pageYOffset;
        }

        this._style.popup.position = fixedAnchor ? 'fixed' : '';

        return base;
    },
    _getFirstFixedParent: function _getFirstFixedParent(elem) {
        while (elem) {
            if (elem.nodeType === 1 && getComputedStyle(elem).getPropertyValue('position') === 'fixed') {
                return elem;
            }

            elem = elem.parentNode;
        }
    },
    _calcTargetDimensions: function _calcTargetDimensions(_ref3) {
        var anchor = _ref3.anchor;

        this.__base.apply(this, arguments);

        anchor = (0, _reactDom.findDOMNode)(this._getAnchorDomNode(anchor));

        var _anchor$getBoundingCl = anchor.getBoundingClientRect(),
            left = _anchor$getBoundingCl.left,
            top = _anchor$getBoundingCl.top;

        // В ie10 document.documentElement.getBoundingClientRect() всегда будет возвращать
        // 0 для top, поэтому использовать его нельзя.


        return {
            left: left + window.pageXOffset,
            top: top + window.pageYOffset,
            width: anchor.offsetWidth,
            height: anchor.offsetHeight
        };
    }
}, {
    propTypes: {
        anchor: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
    }
});